import React, { createContext, useContext, useReducer } from "react";
import chargesReducer, { chargesInitialState } from "./ChargesReducer";

const ChargesContext = createContext(null);

export const ChargesProvider = ({ children }) => {
  const [state, dispatch] = useReducer(chargesReducer, chargesInitialState);

  return (
    <ChargesContext.Provider value={{ state, dispatch }}>
      {children}
    </ChargesContext.Provider>
  );
};

export const useChargesContext = () => {
  const context = useContext(ChargesContext);

  if (!context) {
    throw new Error("useChargesContext must be used within ChargesProvider");
  }

  return context;
};
